
    <fl-modal></fl-modal>
  


// WEBPACK FOOTER //
// ./src/compat/compat-modals.component.ts.CompatModalsComponent.html